import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Card, Row, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";

import { auth } from "../firebase";
import Logo from "../Logo.svg";
import LoadingButton from "../components/LoadingButton";
import FormTextbox from "../components/FormTextbox";

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Email is invalid")
    .required("Email is required")
});

const ForgotPassword = ({ location }) => {
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");

  const handleLogin = async (values, actions) => {
    try {
      await auth().sendPasswordResetEmail(values.email);
      setEmail(values.email);
      actions.setSubmitting(false);
    } catch (error) {
      setError(error.message);
      actions.setSubmitting(false);
    }
  };

  return (
    <Container>
      <Row className="justify-content-center mt-4">
        <Col md="4">
          <Card className="p-4">
            <div className="text-center mb-4">
              <Link to="/">
                <img src={Logo} alt="Logo" height="22" />
              </Link>
            </div>
            {email ? (
              <div className="alert alert-success">
                The password reset email has been sent to {email}.
              </div>
            ) : (
              <div>
                {error && <div className="alert alert-danger">{error}</div>}
                <Formik
                  initialValues={{
                    email: ""
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleLogin}
                >
                  {formik => (
                    <Form noValidate onSubmit={formik.handleSubmit}>
                      <FormTextbox
                        formik={formik}
                        controlId="email"
                        label="KVIS Email"
                      />
                      <LoadingButton
                        isLoading={formik.isSubmitting}
                        variant="primary"
                        type="submit"
                        className="w-100"
                      >
                        Reset Password
                      </LoadingButton>
                    </Form>
                  )}
                </Formik>
                <div className="mt-4">
                  Back to <Link to="/login">Login</Link>
                </div>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
